import { useSession } from '../../contexts/session';

// Where each role can go, read by the router and the top bar alike so the
// routes and the links cannot disagree. home is the page at the root, reached
// through the psy brand and never a link of its own (C28, C33); sections
// are the top bar's entries, in menu order; pages are reached from inside the
// app rather than the bar, and listed only so the phone bar can name them.
// Each label is a key into the messages.
//
// Only the sections built so far are listed: the patient's Journal and
// Sessions and the clinician's Agenda join when they exist.
export const navigation = {
  PATIENT: {
    home: { path: '/', label: 'today' },
    sections: [
      { path: '/diary', label: 'diary' },
      { path: '/tests', label: 'tests' }
    ],
    pages: [
      { path: '/settings', label: 'settings' },
      { path: '/invitations', label: 'invitation' }
    ]
  },
  CLINICIAN: {
    home: { path: '/', label: 'dashboard' },
    sections: [
      { path: '/patients', label: 'patients' }
    ],
    pages: [
      { path: '/settings', label: 'settings' }
    ]
  }
};

// The signed-in person's navigation.
export function useNavigation() {
  const { me } = useSession();

  return navigation[ me.role ];
}
